import images from './images';

const wines = [
  {
    title: 'Chicken',
    price: '$23.50',
    /*tags: 'AU | Bottle',*/
  },
  {
    title: 'Prawn',
    price: '$30.00',
    /*tags: 'AU | Bottle',*/
  },
  {
    title: 'Hot Butter Cuttlefish',
    price: '$28.00',
    /*tags: 'FR | 750 ml',*/
  },
  {
    title: 'Fish',
    price: '$23.00',
    /*tags: 'CA | 750 ml',*/
  },
  {
    title: 'Lamb',
    price: '$23.00',
    /*tags: 'IE | 750 ml',*/
  },
  {
    title: 'Pork',
    price: '$23.00',
    /*tags: 'IE | 750 ml',*/
  },
];

const cocktails = [
  {
    title: 'Chicken / Lamb / Pork Dosa',
    price: '$14.00',
    /*tags: 'Aperol | Villa Marchesi prosecco | soda | 30 ml',*/
  },
  {
    title: "Plain Dosa",
    price: '$10.00',
    /*tags: 'Aperol | Villa Marchesi prosecco | soda | 30 ml',*/
  },
  {
    title: 'Masala Dosa',
    price: '$12.00',
    /*tags: 'Aperol | Villa Marchesi prosecco | soda | 30 ml',*/
  },
  {
    title: 'Onion Dosa',
    price: '$12.00',
    /*tags: 'Aperol | Villa Marchesi prosecco | soda | 30 ml',*/
  },
  {
    title: 'Egg Dosa',
    price: '$11.50',
    /*tags: 'Aperol | Villa Marchesi prosecco | soda | 30 ml',*/
  },
];

const awards = [
  {
        
    title : "",
    subtitle : "Looking for the perfect venue to celebrate a birthday, host a special event, or throw an unforgettable party? Our resturant elegant and versatile spaces tailored to make every occasion truly memorable.Whether it’s an intimate gathering or a grand celebration, we’ve got you covered. We also provide top-notch catering services, offering a variety of delicious menus to suit every taste and occasion. Let our experienced team handle the details so you can focus on enjoying your special day. Book your event with us today and turn every celebration into a cherished memory!",
  },
  /*{
    imgUrl: images.award01,
    title: 'Rising Star',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award05,
    title: 'AA Hospitality',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award03,
    title: 'Outstanding Chef',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },*/
];
const data = {awards, wines, cocktails}

export default data;
